import { motion } from 'framer-motion';
import React, { useState } from 'react';

function SpectacleViewVideo({ urls }) {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <motion.div className="spectacle_video container_cards gap-10 pt-2 pb-10">
      {urls.map((url, index) => {
        const isActive = activeIndex == index;
        return (
          <motion.iframe
            key={index}
            className={`border-2 rounded-lg border-white/50 transition-all duration-500 ${
              isActive
                ? 'fixed top-0 left-0 w-screen h-screen z-50'
                : 'w-60 h-40'
            }`}
            src={`${url}?enablejsapi=1`}
            title="YouTube video player"
            data-index={index}
          ></motion.iframe>
        );
      })}
    </motion.div>
  );
}

export default SpectacleViewVideo;
